import {Injectable} from '@angular/core';
import {AppService} from '../../../core/services/app.service';
import {HttpClient} from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class LikeService {
    likeAPI = AppService.getApiUrl() + '/api/likes';

    constructor(private http: HttpClient) {
    }

    like(params) {
        const url = `${this.likeAPI}`;

        return this.http.put(url, params);
    }

    convertPrettifyNumber(value) {
        let thousand = 1000;
        let million = 1000000;
        let billion = 1000000000;
        if (value < thousand) {
            return String(value);
        }

        if (value >= thousand && value <= 1000000) {
            return Math.floor(value/thousand * 10) / 10 + 'k';
        }

        if (value >= million && value <= billion) {
            return Math.floor(value/thousand * 10) / 10 + 'M';
        }
    }
}

